import React from 'react';
import BootstrapButton from 'react-bootstrap/Button';
import classnames from 'classnames';
import { isEmpty } from 'lodash-es';

import ExternalLinkIcon from '../../../assets/svgComponents/ExternalLinkIcon.jsx';

import styles from './ButtonWithIcon.module.scss';

const ButtonWithIcon = ({
  isExternalLink,
  icon,
  img,
  imgClassName,
  text,
  textClassName,
  variant,
  containerClass,
  ...props
}) => (
  <BootstrapButton
    {...props}
    bsPrefix="boon-icon-btn"
    className={classnames(styles.boonIconBtn, containerClass, variant)}
  >
    {!isEmpty(icon) && !isExternalLink && icon}
    {!isEmpty(img) && !isExternalLink && (
      <img src={img} alt="icon" className={classnames(styles.btnIconStyle, imgClassName)} />
    )}
    {isExternalLink && <ExternalLinkIcon />}
    {!isEmpty(text) && <span className={classnames(styles.btnIconText, textClassName)}>{text}</span>}
  </BootstrapButton>
);

export default ButtonWithIcon;
